import React, { useEffect, useState } from "react";
import { MixStyle } from "../../../styles";
import styled from "styled-components";
import { Row, Col, Form } from "antd";
import { useForm } from "antd/lib/form/util";
import moment from "moment";
import { updateDispatch } from "../../../helper/utils/api/dispatch";
import {
  Modal,
  DatePicker,
  Button,
  Typography,
  Input,
  Loading,
} from "../../../core";

const Notify_Utils = require("../../../helper/utils/Notification");

const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

const StyledForm = styled(Form)`
  label {
    ${MixStyle.Label};
  }
`;

const EditDispatchModal = ({
  editDispatchModal,
  closeModal,
  recordToEdit,
  getDispatchesOfCurrentContract,
}) => {
  let [form] = useForm();
  const [state, setState] = useState();
  const [updatedValue, setUpdatedValue] = React.useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let currentDispatch = {
      ...recordToEdit,
      dispatchDate: moment(recordToEdit.dispatchDate),
    };
    setState(currentDispatch);
  }, [recordToEdit]);

  const closeModalHandler = () => {
    closeModal("editDispatchModalOpen");
  };

  const onFinish = () => {
    editDispatchApiFun();
  };

  const onValuesChange = (changedValues, valuse) => {
    if (changedValues.lShort && state.packiParchiNumber) {
      let netPass =
        parseInt(state && state.kachiQuantity && state.kachiQuantity) -
        parseInt(changedValues.lShort) -
        parseInt(state && state.glrReceived && state.glrReceived);
      form.setFieldsValue({
        netPass,
      });

      setUpdatedValue((prev) => ({
        ...prev,
        ...changedValues,
        netPass,
      }));
    } else {
      setUpdatedValue((prev) => ({
        ...prev,
        ...changedValues,
      }));
    }
  };
  const onFinishFailed = () => {};

  const editDispatchApiFun = async () => {
    debugger;
    let contractId = state.contractId;
    setIsLoading(true);
    try {
      let dispatchIdToEdit = state && state._id && state._id;
      let response = await updateDispatch({
        contractId,
        dispatchIdToEdit,
        updatedValue,
      });

      Notify_Utils.openNotificationWithIcon("success", response.data.message);
      closeModalHandler();
      setIsLoading(false);
      getDispatchesOfCurrentContract();
    } catch (error) {
      setIsLoading(false);
      Notify_Utils.openNotificationWithIcon(
        "error",
        "Error While update Dispatch"
      );
      console.log("error while update", error);
    }
  };

  return (
    <Modal
      closable={true}
      visible={editDispatchModal}
      okText="Add"
      maxwidth="500px"
      footer={false}
      onCancel={closeModalHandler}
      tittle="Edit Dispatch"
    >
      {isLoading ? <Loading /> : null}

      <StyledForm
        autocomplete="off"
        form={form}
        {...layout}
        name="basic"
        initialValues={state}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
        onFinishFailed={onFinishFailed}
      >
        <Row
          gutter={{ xs: 0, sm: 48, md: 48, lg: 48 }}
          type="flex"
          justify="center"
        >
          <Col md={24} sm={18} xs={24}>
            <Form.Item
              label="Date"
              name="dispatchDate"
              rules={[
                {
                  required: true,
                  message: "Please Set Date!",
                },
              ]}
            >
              <DatePicker />
            </Form.Item>
          </Col>
          <Col md={24} sm={18} xs={24}>
            <Form.Item
              label="K.Quantity"
              name="kachiQuantity"
              rules={[
                {
                  required: true,
                  message: "Please Enter Quantity!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col md={24} sm={18} xs={24}>
            <Form.Item
              label="L Short (in meter)"
              name="lShort"
              rules={[
                {
                  required: true,
                  message: "Please Enter L Short ",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col md={24} sm={18} xs={24}>
            <Form.Item
              label="K patch parchi # "
              name="kachiParchiNumber"
              rules={[
                {
                  required: true,
                  message: "Please Enter K patch parchi #  ",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          {state && state.netPass && (
            <Col md={24} sm={18} xs={24}>
              <Form.Item
                label="Net Pass"
                name="netPass"
                rules={[
                  {
                    required: true,
                    message: "Please Enter  Net Pass!",
                  },
                ]}
              >
                <Input disabled />
              </Form.Item>
            </Col>
          )}
          <Col md={24} sm={18} xs={24}></Col>

          <Col xs={24} sm={24}>
            <Row type="flex" justify="space-around">
              <Col sm={10}>
                <Button bg="#404E67" type="primary" htmlType="submit">
                  <Typography
                    text="Update Dispatch"
                    as="h5"
                    noMargin
                    weight="bold"
                    align="center"
                    color="white"
                  />
                </Button>
              </Col>
              <Col sm={10}>
                <Button bg="#404E67" onClick={closeModalHandler}>
                  <Typography
                    text="Cancel"
                    as="h5"
                    noMargin
                    weight="bold"
                    align="center"
                    color="white"
                  />
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </StyledForm>
    </Modal>
  );
};

export default EditDispatchModal;
